import { Box, Chip, IconButton, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { modalColors } from '../DiscussionsModal/styled';

export const InputContainer = styled(Box)({
    padding: '16px',
    borderTop: '1px solid #404040',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
});

export const EmojiPickerContainer = styled(Box)({
    position: 'relative'
});

export const EmojiButton = styled(IconButton)({
    color: modalColors.white
});

export const MessageInput = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#1a1a1a',
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
        },
        '& input, & textarea': {
            color: '#ffffff',
            fontSize: '14px'
        },
        '& input::placeholder, & textarea::placeholder': {
            color: '#888',
            fontSize: '14px'
        }
    }
});

export const SendButton = styled(IconButton)({
    backgroundColor: '#ffa726',
    color: '#000',
    '&:hover': {
        backgroundColor: '#ff9800'
    }
});

export const AttachmentButton = styled(IconButton)({
    color: modalColors.white,
    opacity: 0.6,
    '& svg': {
        fill: 'currentColor'
    }
});

export const AttachmentsBar = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    padding: '8px 16px 0'
});

export const AttachmentChip = styled(Chip)({
    backgroundColor: '#2a2a2a',
    color: modalColors.white,
    fontSize: '12px',
    height: '24px',
    '& .MuiChip-deleteIcon': {
        color: '#888',
        '&:hover': {
            color: modalColors.white
        }
    }
});

export const AlertChip = styled(Chip)({
    backgroundColor: 'rgba(255, 82, 82, 0.15)',
    color: '#ff5252',
    fontSize: '12px',
    height: '24px',
    border: '1px solid rgba(255, 82, 82, 0.4)'
});
